
import Vue from 'vue'
import SearchIcon from '@/assets/svgs/search_icon.svg?inline'
import LocationIcon from '@/assets/svgs/location_icon.svg?inline'
import NearMeIcon from '@/assets/svgs/near_me_icon.svg?inline'
import DropdownIcon from '@/assets/svgs/dropdown_arrow.svg?inline'
import Pill from '@/components/atoms/Pill.vue'
import RemoveIcon from '@/assets/svgs/x_close_icon.svg?inline'
import NavTooltip from '@/components/userProfile/NavTooltip.vue'
import pDebounce from 'p-debounce'

interface ListItem {
  id: number
  name: string
}

export default Vue.extend({
  name: 'Select',
  model: {
    prop: 'value',
    event: 'input',
  },
  components: {
    SearchIcon,
    LocationIcon,
    NearMeIcon,
    DropdownIcon,
    Pill,
    RemoveIcon,
    NavTooltip,
  },
  data: () => ({
    service: new google.maps.places.AutocompleteService(),
    open: false,
    filteredOptions: [] as string[],
  }),
  props: {
    id: String,
    value: [String, Array, Object],
    name: String,
    rules: Array,
    placeholderText: String,
    label: String,
    disable: Boolean,
    tooltipText: String,
    options: Array,
    allowMultiple: {
      type: Boolean,
      required: false,
      default: false,
    },
    typeToFilter: {
      type: Boolean,
      required: false,
      default: false,
    },
    sortOptions: {
      type: Boolean,
      required: false,
      default: false,
    },
    filterAfterFirstCharacter: {
      type: Boolean,
      required: false,
      default: true,
    },
    hideDropdownArrow: {
      type: Boolean,
      required: false,
      default: false,
    },
    icon: String,
    autocomplete: String,
    googlePlaceApi: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  methods: {
    callGooglePlaceApi: pDebounce(async (val: string, context: any) => {
      // Check if search string is numeric. If so, search by regions to include zip codes, otherwise search by cities.
      const searchType = isNaN(parseInt(val)) ? '(cities)' : '(regions)'
      await context.service.getPlacePredictions({
        input: val,
        // We currently only have hiring partners in the US, restricting the results to include only places in the US
        componentRestrictions: { country: 'us' },
        types: [searchType],
      }, context.getMatchingPlaces)
    }, 150),
    getMatchingPlaces: function (predictions, status) {
      if (status !== google.maps.places.PlacesServiceStatus.OK || !predictions) {
        return
      }
      this.filteredOptions = predictions.map(({ description, place_id: placeId, terms }) => (
        { label: description, placeId: placeId, terms: terms }
      ))
    },
    filter: async function (val: string, update: (callbackFn: () => void) => void, abort: () => void) {
      // Starts filtering only once the user has typed a character
      if (this.typeToFilter && this.filterAfterFirstCharacter && val.length < 1 && !(this.value || []).length) {
        abort()
        return
      }
      if (this.googlePlaceApi) {
        if (val.length) await this.callGooglePlaceApi(val, this)
        update(() => {
          // Required callback function but no action required
        })
      } else {
        let options = (this.options as ListItem[]).map(option => {
          return option.name
        })
        if (this.sortOptions) {
          options.sort()
        }
        update(() => {
          const needle = val.toLowerCase()
          this.filteredOptions = options.filter(
            v => v.toLowerCase().indexOf(needle) > -1
          )
        })
      }
    },
    handleBlur: function (e) {
      this.$emit('blur', e)
      // Prevents the user from having to hit backspace twice to clear field
      if (e.target.value === '' && !this.allowMultiple) {
        this.$emit('input', '')
      }
    },
  },
})
